<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="珠宝玉石列表" name="1">
      <ZbysAdd :updataID='updataID'></ZbysAdd>
    </el-tab-pane>
    <el-tab-pane label="分类管理列表" name="2"></el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 安进
 * 珠宝玉石修改
 */
import ZbysAdd from '../../../../static/form/ZbysAdd.vue'
export default {
  components: {
    ZbysAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Zbysgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ZbysUpdate.vue